const normalizeBuyerName = (value: any): string =>
  `${value ?? ""}`
    .normalize("NFC")
    .trim()
    .replace(/\s+/g, " ")
    .toLocaleLowerCase("vi-VN");

export const getInvoiceBuyerName = (invoice: any): string =>
  invoice?.buyerLegalName ||
  invoice?.buyerDisplayName ||
  invoice?.buyerName ||
  "";

export const haveSameInvoiceBuyerName = (invoices: any[]): boolean => {
  if (!Array.isArray(invoices) || invoices.length <= 1) {
    return true;
  }

  const firstBuyerName = normalizeBuyerName(getInvoiceBuyerName(invoices[0]));
  return invoices.every(
    (invoice) =>
      normalizeBuyerName(getInvoiceBuyerName(invoice)) === firstBuyerName,
  );
};

export const haveSameInvoiceBuyerNameAcrossSelections = (
  existingInvoices: any[] = [],
  selectedInvoices: any[] = [],
): boolean =>
  haveSameInvoiceBuyerName([
    ...(existingInvoices || []),
    ...(selectedInvoices || []),
  ]);
